import { appConstants } from "../../constants/appconstants";
import { getApiCall, postApiCall } from "../../utils/ApiMethods";

const FetchSPGlobalPageLabelCountAction = (url) => {
    return async function (dispatch) {
        dispatch({ type: 'LOADING_SPGLOBAL_PAGE_LABEL_COUNT_ACTION' });
        try {
            const data = await getApiCall(`${appConstants.BASE_URL}/mi-page/count-by-url?url=${encodeURIComponent(url)}`);
            var resData = Object.assign({ type: 'SUCCESS_SPGLOBAL_PAGE_LABEL_COUNT_ACTION' }, data);
            dispatch(resData);
        } catch (error) {
            dispatch({ type: 'ERROR_SPGLOBAL_PAGE_LABEL_COUNT_ACTION', error });
        }
    };
};

const FetchSPGlobalPageFilterAction = (subCategory, category) => {
    return async function (dispatch) {
        dispatch({ type: 'LOADING_SPGLOBAL_PAGE_FILTER_ACTION' });
        try {
            // const data = await getApiCall(`${appConstants.BASE_URL}/spglobal/filter?category=${encodeURIComponent(category)}`);
            const data = await getApiCall(`${appConstants.BASE_URL}/spglobal/get-filters?l1Category=${encodeURIComponent(category)}&l2Category=${encodeURIComponent(subCategory)}`);
            var resData = Object.assign({ type: 'SUCCESS_SPGLOBAL_PAGE_FILTER_ACTION' }, data);
            dispatch(resData);
        } catch (error) {
            dispatch({ type: 'ERROR_SPGLOBAL_PAGE_FILTER_ACTION', error });
        }
    };
};

const FetchSPGlobalLineChartAction = (payload = {}, historicalForecastSwitcherIndex = 0) => {
    return async function (dispatch) {
        dispatch({ type: 'LOADING_SPGLOBAL_LINE_CHART_ACTION' });
        try {
            const endpoint = historicalForecastSwitcherIndex === 0 ? '/spglobal/pricing' : '/spglobal/forecast-pricing';
            const data = await postApiCall(`${appConstants.BASE_URL}${endpoint}`, payload);
            var resData = Object.assign({ type: 'SUCCESS_SPGLOBAL_LINE_CHART_ACTION' }, data);
            dispatch(resData);
        } catch (error) {
            dispatch({ type: 'ERROR_SPGLOBAL_LINE_CHART_ACTION', error });
        }
    };
};

const FetchSPGlobalTableAction = (payload = {}, historicalForecastSwitcherIndex = 0) => {
    return async function (dispatch) {
        dispatch({ type: 'LOADING_SPGLOBAL_TABLE_ACTION' });
        try {
            const endpoint = historicalForecastSwitcherIndex === 0 ? '/spglobal/product-price-details' : '/spglobal/forecast-product-price-details';
            const data = await postApiCall(`${appConstants.BASE_URL}${endpoint}`, payload);
            var resData = Object.assign({ type: 'SUCCESS_SPGLOBAL_TABLE_ACTION' }, data);
            dispatch(resData);
        } catch (error) {
            dispatch({ type: 'ERROR_SPGLOBAL_TABLE_ACTION', error });
        }
    };
};

const FetchSPGlobalDateAction = (category) => {
    return async function (dispatch) {
        dispatch({ type: 'LOADING_SPGLOBAL_DATE_ACTION' });
        try {
            const data = await getApiCall(`${appConstants.BASE_URL}/spglobal/min-max-date`);
            var resData = Object.assign({ type: 'SUCCESS_SPGLOBAL_DATE_ACTION' }, data);
            dispatch(resData);
        } catch (error) {
            dispatch({ type: 'ERROR_SPGLOBAL_DATE_ACTION', error });
        }
    };
};

const FetchSPGlobalDetailReportAction = (payload = {}) => {
    return async function (dispatch) {
        dispatch({ type: 'LOADING_SPGLOBAL_DETAIL_REPORT_ACTION' });
        try {
            const data = await getApiCall(`${appConstants.BASE_URL}/spglobal/reports?fromDate=${payload?.fromDate}&toDate=${payload?.toDate}`);
            var resData = Object.assign({ type: 'SUCCESS_SPGLOBAL_DETAIL_REPORT_ACTION' }, data);
            dispatch(resData);
        } catch (error) {
            dispatch({ type: 'ERROR_SPGLOBAL_DETAIL_REPORT_ACTION', error });
        }
    };
};

export {
    FetchSPGlobalPageLabelCountAction,
    FetchSPGlobalPageFilterAction,
    FetchSPGlobalLineChartAction,
    FetchSPGlobalTableAction,
    FetchSPGlobalDateAction,
    FetchSPGlobalDetailReportAction,
};
